// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast__toast___XXr3v","toastClose":"Toast__toastClose___18lU4"};